



























































































import {Component, Emit, Prop, PropSync} from "vue-property-decorator";
import {Lading, Warehouse} from "@/interfaces/entity";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import moment from "moment";
import {WarehouseStore} from "@/modules/warehouses/store";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import {FORMAT_DATE_TIME_PICKER, PAGE_SIZE_OPTIONS} from "@/shared/constant";
import {LadingType, SiteTargetType} from "@/enums/type";
import LadingTypeLabel from "@/modules/ladings/List/components/TypeLabel.vue";
import TooltipLabel from "@/shared/components/TooltipLabel/TooltipLabel.vue";
import {deleteLading} from "@/modules/ladings/services";
import {PaginationMeta} from "@/interfaces/common";
import {LadingStatus} from "@/enums/status";
import {LadingStore} from "@/modules/ladings/store";

@Component({
    name: "PrintTable",
    components: {TooltipLabel, LadingTypeLabel, LadingStatusLabel}
})
export default class extends mixins(CommonMixin) {
    @PropSync("dataSource", {required: true}) syncDataSource!: Array<any>;
    @PropSync("selectedIds", {type: Array}) syncSelectedIds!: Array<string>;
    @PropSync("meta", {type: Object}) syncMeta!: any;
    @PropSync("isDeleting", {type: Boolean}) syncIsDeleting!: boolean;

    moment = moment;
    columns = [
        {
            title: "Thao tác",
            dataIndex: "rowGuid",
            key: "rowGuid",
            scopedSlots: {customRender: 'action'},
            fixed: 'left',
            width: 100,
            align: 'center'
        },
        {
            title: "Ngày, giờ chấp nhận",
            dataIndex: "ladingDate",
            key: "ladingDate",
            width: 150,
            fixed: "left",
            ellipsis: true,
            scopedSlots: {customRender: 'ladingDate'}
        },
        {
            title: "Mã vận đơn",
            dataIndex: "ladingCode",
            key: "ladingCode",
            width: 150,
            fixed: "left",
            ellipsis: true,
            scopedSlots: {customRender: 'ladingCode'}
        },
        {
            title: "Nhân viên giữ",
            dataIndex: "holdTargetType",
            key: "holdTargetType",
            scopedSlots: {customRender: "holdTargetType"},
            width: 150,
            ellipsis: true
        },
        // {
        //     title: "Mã đơn hàng",
        //     dataIndex: "orderCode",
        //     key: "orderCode",
        //     width: 150,
        //     ellipsis: true,
        //     scopedSlots: {customRender: 'orderCode'}
        // },
        {
            title: "Đại diện gửi",
            dataIndex: "locationFromId",
            key: "locationFromId",
            scopedSlots: {customRender: "locationFromId"},
            width: 200,
            ellipsis: true
        },
        {
            title: "Mã KH",
            dataIndex: "customer.customerCode",
            key: "customerCode",
            width: 150,
            ellipsis: true,
            scopedSlots: {customRender: 'customerCode'}
        },
        // {
        //     title: "Người nhận",
        //     dataIndex: "locationToId",
        //     key: "locationToId",
        //     scopedSlots: {customRender: "locationToId"},
        //     width: 200,
        //     ellipsis: true
        // },
        {
            title: "Địa chỉ giao hàng",
            dataIndex: "locationTo",
            key: "locationToAddress",
            scopedSlots: {customRender: "locationToAddress"},
            width: 200,
            ellipsis: true
        },
        // {
        //     title: "Hàng hóa",
        //     dataIndex: "boxContent",
        //     key: "boxContent",
        //     width: 150,
        //     ellipsis: true
        // },
        // {
        //     title: "Ngày lập",
        //     dataIndex: "ladingDate",
        //     key: "ladingDate",
        //     scopedSlots: {customRender: "ladingDate"},
        //     width: 200,
        //     ellipsis: true
        // },
        // {
        //     title: "Thu hộ",
        //     dataIndex: "codMoney",
        //     key: "codMoney",
        //     scopedSlots: {customRender: "codMoney"},
        //     width: 150,
        //     ellipsis: true
        // },
        // {
        //     title: "Tổng cước",
        //     dataIndex: "totalFee",
        //     key: "totalFee",
        //     scopedSlots: {customRender: "totalFee"},
        //     width: 150,
        //     ellipsis: true
        // },
        {
            title: "TL",
            dataIndex: "weightTemp",
            key: "weightTemp",
            scopedSlots: {customRender: "weightTemp"},
            width: 100,
            ellipsis: true
        },
        {
            title: "SK",
            dataIndex: "boxQuantity",
            key: "boxQuantity",
            scopedSlots: {customRender: "boxQuantity"},
            width: 100,
            ellipsis: true
        },
        {
            title: "Dịch vụ",
            dataIndex: "freightService",
            key: "freightServiceRowGuid",
            scopedSlots: {customRender: "freightService"},
            width: 120,
            ellipsis: true
        },
        {
            title: "DV_GTGT",
            dataIndex: "freightServiceAdds",
            key: "freightServiceAdds",
            scopedSlots: {customRender: "freightServiceAdds"},
            width: 150,
            ellipsis: true
        },
        {
            title: "Thu tiền NN",
            dataIndex: "receiverCollect",
            key: "receiverCollect",
            scopedSlots: {customRender: "receiverCollect"},
            width: 120,
            ellipsis: true
        },
        {
            title: "Trạng thái",
            dataIndex: "status",
            key: "status",
            scopedSlots: {customRender: 'status'},
            width: 250,
            ellipsis: true
        },
    ];
    LadingType = LadingType;
    isDeleting = false;
    listStatusDeliveryBackStockIn = [
        LadingStatus.PhatLai,
        LadingStatus.DonSuCo,
        LadingStatus.DuyetHoan,
        LadingStatus.DuyetChuyenTiep
    ]
    siteTargetType = SiteTargetType;
    FORMAT_DATE_TIME_PICKER = FORMAT_DATE_TIME_PICKER;

    onSelectChange(selectedRowKeys: any) {
        this.syncSelectedIds = selectedRowKeys;
        LadingStore.updateSelectedRowLadings(selectedRowKeys);
    }

    get pagination() {
        return {
            showTotal: (total: number) => `Tổng cộng ${total} vận đơn`,
            showQuickJumper: true,
            showSizeChanger: true,
        }
    }

    @Emit("onChangePage")
    onChangePage(pagination: any) {
        return pagination;
    }

    @Emit("onDelete")
    onConfirmDelete(ladingId: string) {
        return ladingId;
    }
}
